/**
 * Creates a reset action that restores state to initialState.
 */
export function createReset<T extends object>(
  set: (fn: (state: T) => void) => void,
  initialState: T,
): () => void {
  return () => {
    set((state) => {
      Object.assign(state, initialState);
    });
  };
}
